import { useEffect, useState } from 'react';
import useQueryApiClient from './useQueryApiClient';
import { useDebounce } from './useDebounce';

interface AvailableOptions {
  transaction_types: string[];
  statuses: string[];
  main_categories: Array<{ id: number; name: string }>;
  sub_categories: Array<{ id: number; name: string; parent_id: number }>;
  sub_subcategories: Array<{ id: number; name: string; parent_id: number }>;
}

interface LocationFilter {
  location?: string;
  lks_lat?: number | null;
  lks_long?: number | null;
  distance_radius?: number;
  status?: string[];
}

export const useAvailableFilterOptions = (filter: LocationFilter) => {
  const [availableOptions, setAvailableOptions] = useState<AvailableOptions | null>(null);
  const debouncedDistanceRadius = useDebounce(filter.distance_radius, 500);

  const hasLocation = filter.location || (filter.lks_lat && filter.lks_long);
  const hasDistance = !!debouncedDistanceRadius;
  const isLocationFilterActive = hasLocation && hasDistance;

  const { isLoading, appendData } = useQueryApiClient({
    request: {
      url: 'api/v2/wholesale/listings/available-options',
      disableOnMount: true,
    },
    onSuccess: (response) => {
      setAvailableOptions(response);
    },
  });

  useEffect(() => {
    appendData({ filter: { ...filter, distance_radius: debouncedDistanceRadius } });
  }, [filter.location, filter.lks_lat, filter.lks_long, debouncedDistanceRadius, JSON.stringify(filter.status)]);

  return {
    availableOptions,
    isLoadingOptions: isLoading,
    isLocationFilterActive,
  };
};
